import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const MemberLoginShema = Yup.object().shape({
  phone: Yup.string().required(),
  password: Yup.string().required(),
});
